/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import TemplatePreviewModal from './PreviewModal'

import 'bootstrap-icons/font/bootstrap-icons.css'
import './OurTemplate.scss'
import {
  GetAllCategory,
  getOurTemplateList,
  getAllCategoryList,
  getOurTemplate,
} from './OurTemplateSlice/OurTemplateSlice'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {openPopup} from '../../../../Components/PopupSlice/popupSlice'

const OurTemplates = ({data, setData}: any) => {
  const dispatch = useDispatch()
  const [visible, setVisble] = useState({
    open: false,
    data: {},
  })
  const [filterName, setFilterName] = useState<any>({type: 'MMS'})
  const Templates: [] = useSelector(getOurTemplateList)
  const Category = useSelector(getAllCategoryList)

  const MMSList = Templates?.filter((key: any) => key?.type == 'MMS')
  const SMSList = Templates?.filter((key: any) => key?.type == 'SMS')

  useEffect(() => {
    dispatch(getOurTemplate(filterName))
  }, [filterName])

  useEffect(() => {
    dispatch(GetAllCategory())
  }, [])

  return (
    <>
      <TemplatePreviewModal
        setdata={setData}
        data={data}
        show={visible}
        handleClose={() => setVisble({...visible, open: false})}
      />
      <div className='card'>
        <div className='card-header border-0 pt-12 px-14'>
          <h3 className='card-title align-items-start flex-column me-5'>
            <span className='card-label fw-bolder fs-3 mb-1'>Choose from our templates</span>
            <span className='text-muted mt-1 fw-light fs-7'>
              If you still need more info, visit{' '}
              <a onClick={() => dispatch(openPopup('Dummy text'))} className='fw-light'>
                Help Page
              </a>
            </span>
          </h3>
        </div>
        <div className='card-body px-14'>
          <div className='row d-flex'>
            <div className='col-3 template-left'>
              {/* <TemplateAsideMenu  filterName={setFilterName}/> */}
              <div className='menu-item'>
                <div className='menu-content'>
                  <span className='menu-section text-muted text-uppercase ls-1'>Type</span>
                </div>
              </div>
              <span className='cursor-pointer' onClick={() => setFilterName({type: 'MMS'})}>
                <p>MMS</p>
              </span>
              <span
                className='cursor-pointer'
                onClick={() => {
                  setFilterName({type: 'SMS'})
                }}
              >
                <p>SMS</p>
              </span>
              <div className='menu-item'>
                <div className='menu-content'>
                  <span className='menu-section text-muted text-uppercase ls-1'>Category</span>
                </div>
              </div>
              {Category?.data?.category?.map((val: any, i: number) => (
                <span
                  key={i}
                  className='row cursor-pointer'
                  onClick={() => setFilterName({category: val?._id})}
                >
                  <p className='col-10'>{val._id}</p>
                  <span className='col-2'>{val?.total}</span>
                </span>
              ))}
              <div className='menu-item'>
                <div className='menu-content'>
                  <span className='menu-section text-muted text-uppercase ls-1'>Industry</span>
                </div>
              </div>
              {Category?.data?.industry?.map((val: any, i: number) => (
                <span
                  key={i}
                  className='row cursor-pointer'
                  onClick={() => setFilterName({industry: val?._id})}
                >
                  <p className='col-10'>{val._id}</p>
                  <span className='col-2'>{val?.total}</span>
                </span>
              ))}
            </div>
            <div className='col-9 template-right'>
              <span
                className='fw-bolder d-flex justify-content-start border-bottom-dashed border-gray-400 pb-3'
                style={{borderBottomWidth: '1.5px'}}
              >
                {filterName?.type || filterName?.industry || filterName?.category}
              </span>

              {/* <span className='fw-bolder d-flex justify-content-start'>MMS</span> */}
              {
                <div className='row template-wrap flex-wrap pt-5'>
                  {MMSList?.length !== 0 && (
                    <>
                      {/* <h1 className='fw-bolder d-flex justify-content-start'>MMS</h1> */}
                      {Templates?.map((key: any, i: number) => {
                        return (
                          <React.Fragment key={i}>
                            {key.type == 'MMS' && (
                              <div key={key?._id} className='col-4 d-flex flex-column mms-box-wrap'>
                                <div
                                  className=' mt-3'
                                  onClick={() => {
                                    setData({
                                      ...data,
                                      imageUrl: key?.imageUrl,
                                      content: key?.content,
                                    })
                                  }}
                                >
                                  <img
                                    alt='Logo'
                                    src={key?.media}
                                    className='w-100 border-10 rounded h-200px'
                                  />
                                </div>
                                <div className='mt-3'>
                                  <div className='tags-wrapper'>
                                    {/* <a className={'badge badge-light-success me-2'}></a> */}
                                    {key?.tags?.map((tags: any, i: number) => {
                                      return (
                                        <a key={i} className={'badge badge-light-primary'}>
                                          {tags}
                                        </a>
                                      )
                                    })}
                                    {/* <a className={'badge badge-light-danger me-2'}>Sale</a>
                  <a className={'badge badge-light-primary'}>Technology</a> */}
                                  </div>
                                </div>
                                <div className='mt-3'>
                                  <p className='user-title'>{key?.message}</p>
                                </div>
                                <div className='mt-3 d-flex justify-content-between'>
                                  <div className='btn-wrap mb-5'>
                                    <div className='mt-2 col-8'>
                                      <span className='col-4'>
                                        <img
                                          src={toAbsoluteUrl('/media/mobile/calandar.svg')}
                                          alt='Calander'
                                          className='calendar_icon'
                                        />
                                      </span>
                                      {key?.message?.split('')?.length}
                                      <span className='col-8'>
                                        {key?.content?.split('')?.length}
                                      </span>
                                    </div>
                                    <div>
                                      <button
                                        className='btn btn-sm btn-light btn-primary me-2 w-70px px-3 fw-light'
                                        onClick={() =>
                                          setVisble({...visible, open: true, data: key})
                                        }
                                      >
                                        Preview
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </React.Fragment>
                        )
                      })}
                    </>
                  )}

                  {SMSList?.length !== 0 && (
                    <>
                      {/* <h1 className='fw-bolder d-flex justify-content-start'>SMS</h1> */}
                      {Templates?.map((key: any, i: number) => {
                        return (
                          <React.Fragment key={i}>
                            {key.type == 'SMS' && (
                              <div key={key?._id} className='col-4 d-flex flex-column mms-box-wrap'>
                                <div
                                  className=' mt-3'
                                  onClick={() => {
                                    setData({
                                      ...data,
                                      imageUrl: key?.imageUrl,
                                      content: key?.content,
                                    })
                                  }}
                                ></div>
                                <div className='mt-3'>
                                  <div className='tags-wrapper'>
                                    {/* <a className={'badge badge-light-success me-2'}></a> */}
                                    {key?.tags?.map((tags: any, i: number) => {
                                      return (
                                        <a key={i} className={'badge badge-light-primary'}>
                                          {tags}
                                        </a>
                                      )
                                    })}
                                    {/* <a className={'badge badge-light-danger me-2'}>Sale</a>
                  <a className={'badge badge-light-primary'}>Technology</a> */}
                                  </div>
                                </div>
                                <div className='mt-3'>
                                  <p className='user-title'>{key?.message}</p>
                                </div>
                                <div className='mt-3 d-flex justify-content-between'>
                                  <div className='btn-wrap mb-5'>
                                    <div className='mt-2'>
                                      <span className='col-4'>
                                        <svg
                                          width='18'
                                          height='18'
                                          viewBox='0 0 18 18'
                                          fill='none'
                                          xmlns='http://www.w3.org/2000/svg'
                                        >
                                          <rect
                                            x='2.24707'
                                            y='2.99756'
                                            width='13.5056'
                                            height='12.005'
                                            rx='2'
                                            stroke='#191C30'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                          />
                                          <path
                                            d='M12.0015 12.3764H5.99902'
                                            stroke='#191C30'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                          />
                                          <path
                                            d='M10.257 9.27556C10.257 9.30037 10.2669 9.32415 10.2845 9.34162C10.3021 9.35909 10.3259 9.3688 10.3507 9.3686C10.3887 9.3686 10.423 9.34567 10.4375 9.31053C10.4519 9.27539 10.4438 9.23499 10.4168 9.20823C10.3898 9.18147 10.3494 9.17363 10.3143 9.18838C10.2793 9.20314 10.2567 9.23756 10.257 9.27556'
                                            stroke='#191C30'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                          />
                                          <path
                                            d='M12.9581 9.27556C12.9581 9.30037 12.968 9.32415 12.9856 9.34162C13.0033 9.35909 13.0271 9.3688 13.0519 9.3686C13.0899 9.3686 13.1242 9.34567 13.1386 9.31053C13.1531 9.27539 13.1449 9.23499 13.118 9.20823C13.091 9.18147 13.0505 9.17363 13.0155 9.18838C12.9805 9.20314 12.9578 9.23756 12.9581 9.27556'
                                            stroke='#191C30'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                          />
                                          <path
                                            d='M7.55578 9.27556C7.55578 9.30037 7.56569 9.32415 7.5833 9.34162C7.60091 9.35909 7.62477 9.3688 7.64957 9.3686C7.68757 9.3686 7.72182 9.34567 7.73629 9.31053C7.75076 9.27539 7.7426 9.23499 7.71562 9.20823C7.68864 9.18147 7.64818 9.17363 7.61316 9.18838C7.57814 9.20314 7.55548 9.23756 7.55578 9.27556'
                                            stroke='#191C30'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                          />
                                          <path
                                            d='M4.85461 9.27556C4.85461 9.30037 4.86452 9.32415 4.88213 9.34162C4.89974 9.35909 4.92359 9.3688 4.9484 9.3686C4.9864 9.3686 5.02065 9.34567 5.03512 9.31053C5.04959 9.27539 5.04143 9.23499 5.01445 9.20823C4.98747 9.18147 4.94701 9.17363 4.91199 9.18838C4.87696 9.20314 4.85431 9.23756 4.85461 9.27556'
                                            stroke='#191C30'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                          />
                                          <path
                                            d='M4.85461 6.56168C4.85461 6.61348 4.8966 6.65547 4.9484 6.65547C5.0002 6.65547 5.04219 6.61348 5.04219 6.56168C5.04219 6.50988 5.0002 6.46789 4.9484 6.46789C4.8966 6.46789 4.85461 6.50988 4.85461 6.56168'
                                            stroke='#191C30'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                          />
                                          <path
                                            d='M7.55578 6.56168C7.55578 6.61348 7.59777 6.65547 7.64957 6.65547C7.70137 6.65547 7.74336 6.61348 7.74336 6.56168C7.74336 6.50988 7.70137 6.46789 7.64957 6.46789C7.59777 6.46789 7.55578 6.50988 7.55578 6.56168'
                                            stroke='#191C30'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                          />
                                          <path
                                            d='M10.257 6.56168C10.257 6.61348 10.2989 6.65547 10.3507 6.65547C10.4025 6.65547 10.4445 6.61348 10.4445 6.56168C10.4445 6.50988 10.4025 6.46789 10.3507 6.46789C10.2989 6.46789 10.257 6.50988 10.257 6.56168'
                                            stroke='#191C30'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                          />
                                          <path
                                            d='M12.9581 6.56168C12.9581 6.61348 13.0001 6.65547 13.0519 6.65547C13.1037 6.65547 13.1457 6.61348 13.1457 6.56168C13.1457 6.50988 13.1037 6.46789 13.0519 6.46789C13.0001 6.46789 12.9581 6.50988 12.9581 6.56168'
                                            stroke='#191C30'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                          />
                                        </svg>
                                      </span>
                                      <span className='col-8'>
                                        {key?.content?.split('')?.length}
                                      </span>
                                    </div>
                                    <div>
                                      <button
                                        className='btn btn-sm btn-light btn-primary w-70px px-3 fw-light'
                                        onClick={() =>
                                          setVisble({...visible, open: true, data: key})
                                        }
                                      >
                                        Preview
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </React.Fragment>
                        )
                      })}
                    </>
                  )}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OurTemplates
